import React, {useState} from "react";
import Modal from 'react-awesome-modal'
import './text-popup.styles.css'
import { Title } from "../../components/title/title.component";
import TtmButton from "../../components/button/button.component";

export const TextPopup = (props) => {
    const [visible, setVisible] = useState(props.visible);
    const [title, setTitle] = useState("");
    const [text, setText] = useState("");
    const [buttonText, setButtonText] = useState("");
    const [buttonLink, setButtonLink] = useState("");
    const [closable, setClosable] = useState(true);
    window.setTextWindow = (visible, inputTitle, inputText, inputBtnText, inputBtnLink, closable=true, blurred=false) => {
        setVisible (visible);
        setTitle(inputTitle);
        setText(inputText);
        setButtonText(inputBtnText);
        setButtonLink(inputBtnLink);
        setClosable(closable);
        if(blurred){
            document.querySelector(".App > div:not(.modal-container)").style.filter = "blur(10px)"
        }
      }
      window.textVisible = () => {
        return visible;
      }
    return (
        <div className="modal-container"> 
        <Modal visible={visible} effect="fadeInUp" onClickAway={() => closable?setVisible(false):null}>
            <div className="text-popup-container">
                <div className="contents">
                    <Title title={title} description={text}></Title>
                    <TtmButton text={buttonText} href={buttonLink} onClick={()=>{
                    }}></TtmButton>
                </div>
            </div>
        </Modal>
        </div>
    )
}